import gql from 'graphql-tag'


export const IS_ME = gql`
         query isMe {
           isMe {
             channelId
             profileImageUrl
             displayName
           }
         }
       `;